export const REQUEST_INFORMATION_TYPES = [
  'Contribution',
  'Corporate Responsibility',
  'Emergency Response Plan',
  'Evacuation Distances',
  'Integrity Management',
  'Prevention Measures Undertaken',
  'Safety Data Sheet',
  'Safety',
  'Other',
] as const

export const REQUEST_MEETING_TYPES = [
  'Capabilities',
  'General',
  'Mock Drill',
  'Operational Concern',
  'Tour',
  'Training Exercise',
  'Other',
] as const

export const REPORT_ISSUE_TYPES = [
  'Condition of Right-of-Way',
  'Damage to Facility',
  'Digging / Encroachment Near Pipe',
  'Exposed Pipe',
  'Missing Signage',
  'Suspicious Activity',
  'Other',
] as const

export const REGISTER_SITE_TYPES = [
  'Apartments',
  'Athletic Facilities (Stadiums, Arena Fields, Ball Parks, Stable)',
  'Business',
  'Church',
  'Concession Stands',
  'Daycare',
  'Entertainment district or facility',
  'Fishing Ponds',
  'Golf courses',
  'Hospital',
  'Industrial Parks',
  'ManCamps',
  'Monastery',
  'Motels',
  'Parks',
  'Prison',
  'Racetracks',
  'Rest Areas',
  'Roadside Parks',
  'RV/Campground/Trailer Park',
  'Schools',
  'Senior Center',
  'Strip Shopping Centers',
  'Visitor Centers',
  'Waterway',
  'Other',
] as const

export function requestTypeOptions(requestType: string): readonly string[] {
  switch (requestType) {
    case 'Request Information':
      return REQUEST_INFORMATION_TYPES
    case 'Request A Meeting':
      return REQUEST_MEETING_TYPES
    case 'Report An Issue':
      return REPORT_ISSUE_TYPES
    case 'Register an Identified Site':
      return REGISTER_SITE_TYPES
    default:
      return []
  }
}

export function requestTypeNeedsCategory(requestType: string): boolean {
  return (
    requestType !== 'Ask A Question' &&
    requestType !== 'Request an Unlisted Operator'
  )
}
